import VVSTable from "components/form-control/VVSTable";
import React from "react";
import { Container } from "reactstrap";

export default function Category() {
  const handleBeforeSave = row => {
    row.Category = "questionCategory";
    row.Name = row.Name;
    row.value = row.value;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <VVSTable
            name="QuestionCategory"
            title={"Chủ đề"}
            whereQuery={{
              Category: "questionCategory",
              objectId: {
                $ne: "nBHAwgRxHL",
              },
            }}
            enableInlineEdit
            beforeSaveInlineEdit={handleBeforeSave}
          />
        </Container>
      </div>
    </React.Fragment>
  );
}
